const en = {
  //新项目语言配置,
  searchInformation: 'Search',
  moreInformation: 'More information',
  noMore: 'No more',
  allComments: 'All comments',
  allReply: 'All reply',
  wantToSay: 'Write a comment',
  cancle: 'Cancel',
  publish: 'Post',
  pleaseEnterComment: 'Write a comment',
  peopleSaw: 'viewed',
  like: 'Like',
  goodArticle: 'Like',
  fromLable: 'Tags',
  noLabel: 'No tag',
  relatedArticles: 'Related posts',
  moreArticle: 'More posts',
  everyoneSaying: 'Comments',
  lookAll: 'See all',
  pieceReply: 'Replies',
  noComment: 'No comment',
  moreComment: 'More comments',
  replySomeone: 'Reply to',
  noSearchResults: 'No search results yet',
  viewMore: 'See more',
  searchRecords: 'Search record',
  clearRecords: 'Clear History',
  noSearchHistoryYet: 'No search history yet',
  noHotNews: 'No popular posts',
  hotArticle: 'Popular posts',
  delete: 'Delete',
  deleteCommentOk: 'Successful',
  noData: 'No data',
  requestFail: 'Request failed',
  newsDataLoading: 'Loading',
  newsDataRequestTimeOut: 'Timeout, click to Retry',
  doCommentFail: 'Comment failed',
  doLikeFail: 'Praise failed',
  doCancelLikeFail: 'Cancel likes failed',
  loading: 'Loading...',
  loadFail:'Failed to load'
}
export default en;



// WEBPACK FOOTER //
// ./src/i18n/config/en.js